module.exports = __webpack_public_path__ + "static/img/h2.90493ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h2.jpg
// module id = u+gh
// module chunks = 0